// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2PdNO","log":"ModalInventoryLogs_log__1zqsO","date":"ModalInventoryLogs_date__yhkHC","userName":"ModalInventoryLogs_userName__2RDfu"};